module.exports = __webpack_public_path__ + "static/media/9-min.7ebd090f.jpg";